import React from "react";
import { observer } from "mobx-react-lite";
import styles from "./AddChatToContactsModal.module.scss";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import { Button } from "@whatslly/ui-components/v2/Button";
import { useTranslation } from "react-i18next";

export const AddChatToContactsModal: React.FC<IModalInstance<{ type: "create" | "assign" }>> = observer(({ closeModal }) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      testId={`add_chat_to_contacts_modal`}
      backdropClassName={styles.backdrop}
      bodyClassName={styles.modalBody}
      className={styles.modal}
      closeModal={closeModal}
      closeOnClickOutside={true}
      closeOnEscape={false}
      headerClassName={styles.header}
      header={<ModalHeader closeModal={closeModal} />}
    >
      <Button testId={`create_new_contact_button`} secondary={true} onClick={() => closeModal({ type: `create` })}>
        {t("whatsapp_business_api_agent_page.create_new_contact")}
      </Button>
      <Button testId={`add_to_existing_contact_button`} secondary={true} onClick={() => closeModal({ type: `assign` })}>
        {t("whatsapp_business_api_agent_page.add_to_existing_contact")}
      </Button>
    </BaseModal>
  );
});
